import { WP_API_URL } from "../constants/wordpress";

export class WordPressPageError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "WordPressPageError";
    this.status = status;
  }
}

function getWpApiBase() {
  if (process.env.NODE_ENV === "development") {
    return "/api/wp";
  }
  return WP_API_URL.replace(/\/+$/, "");
}

export async function fetchPageBySlug(slug, { lang } = {}) {
  if (!slug) {
    throw new WordPressPageError("Page slug is required", 400);
  }

  const params = new URLSearchParams({
    slug,
    _embed: "1",
  });

  if (lang) {
    params.set("lang", lang);
  }

  const url = `${getWpApiBase()}/wp/v2/pages?${params.toString()}`;
  const response = await fetch(url, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new WordPressPageError(
      `WordPress page fetch failed (${response.status})`,
      response.status,
    );
  }

  const pages = await response.json();
  return pages[0] || null;
}

export function getFeaturedImageUrl(page) {
  return page?._embedded?.["wp:featuredmedia"]?.[0]?.source_url || null;
}

export function stripHtml(html = "") {
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}
